<template>
  <div class="satellite-container">
    <div class="title-box">
      <div class="title-left">
        <div class="sign"></div>
        <span>{{ title || "卫星图" }}</span>
      </div>
      <div class="title-right"></div>
    </div>
    <div class="head-box">
      <div
        :class="{ 'btn-tab': true, 'tab-active': activeTab === '0' }"
        @click="changetab('0')"
      >
        <span>红外云图</span>
      </div>
      <div
        :class="{ 'btn-tab': true, 'tab-active': activeTab === '1' }"
        @click="changetab('1')"
      >
        <span>可见光图</span>
      </div>
      <div
        :class="{ 'btn-tab': true, 'tab-active': activeTab === '2' }"
        @click="changetab('2')"
      >
        <span>水汽云图</span>
      </div>
    </div>
    <div class="body-box">
      <div class="views">
        <img :src="viewsSrc" />
      </div>
      <div class="plays">
        <div class="slt-param">
          <div class="param-item" @click="showPiker('time')">
            <span>{{ startTime }}</span
            ><i class="i-right"></i>
          </div>
        </div>
        <div class="slt-view">
          <div
            class="img-tabs"
            v-for="(item, i) in mapdata"
            v-bind:key="i"
            @click="imgBtnClick(i)"
          >
            <img :src="item.imgurl" />
            <span :class="{ 'active-span': currimgbtn == i }">{{
              item.time
            }}</span>
          </div>
        </div>
        <div class="play-coms">
          <playbox
            ref="play"
            :btnIndex="currimgbtn"
            :mapData="mapdata"
            @changeIndex="changeBtnIndex"
          ></playbox>
        </div>
        <van-popup v-model="show" position="bottom">
          <van-datetime-picker
            v-if="popupkey == 'time'"
            v-model="currentDate"
            type="date"
            :min-date="minDate"
            :max-date="maxDate"
            @cancel="show = false"
            @confirm="onConTimefirm"
            item-height="40"
            visible-item-count="3"
          />
        </van-popup>
      </div>
    </div>
    <mypopup :canclose="true" />
  </div>
</template>

<script>
import playbox from "@/components/playBox";
import mypopup from "@/components/my-popup";
export default {
  name: "satellite",
  components: {
    playbox,
    mypopup
  },
  data() {
    return {
      title: "",
      activeTab: "0",
      paramArr: [
        "SAT_FY4A_HDF_L_IR2_P2_ToM",
        "SAT_FY4A_HDF_L_VIS_P2_ToM",
        "SAT_FY4A_HDF_L_IR3_P2_ToM"
      ],
      popupkey: "time",
      show: false,
      viewsSrc: "",
      currInterval: "", //当前定时器
      currentDate: new Date(), //当前时间
      minDate: new Date(2020, 0, 1),
      maxDate: new Date(2025, 10, 1),
      startTime: this.$btools.fuc.formatDate(new Date(), "yyyy-MM-dd"), //查询起始时间
      endTime: this.$btools.fuc.formatDate(new Date(), "yyyy-MM-dd"), //查询结束时间
      weatherText: "中国-925hpa-基本天气分析",
      weatherCode: "CHINA_H925_WEATHERCHART",
      columnsVal: [
        ["CHINA", "ASIA", "NORTH"],
        ["H925", "H850", "H700", "H500", "H200", "H100"],
        ["WEATHERCHART", "CLOUD", "RADAR"] //china_h000
      ],
      columns: [
        {
          values: ["中国", "亚欧区域", "北半球区域"],
          defaultIndex: 0
        },
        {
          values: ["925hpa", "850hpa", "700hpa", "500hpa", "200hpa", "100hpa"],
          defaultIndex: 0
        },
        {
          values: ["基本天气分析", "叠加卫星云图", "叠加雷达拼图"],
          defaultIndex: 0
        }
      ],
      currimgbtn: 0,
      mapdata: []
    };
  },
  mounted() {
    let that = this;
    that.getData();
    //that.makeTestData();
    //that.initMap();
  },
  watch: {
    currimgbtn(v) {
      this.viewsSrc = this.mapdata.length > 0 ? this.mapdata[v]["imgurl"] : "";
    },
    mapdata() {
      this.currimgbtn = 0;
      this.viewsSrc =
        this.mapdata.length > 0 ? this.mapdata[this.currimgbtn]["imgurl"] : "";
    },
    activeTab() {
      this.getData();
    }
  },
  methods: {
    changetab(index) {
      this.activeTab = index;
    },
    changeBtnIndex(idx) {
      this.currimgbtn = idx;
    },
    //遮罩层显示隐藏及显示内容处理
    showPiker(k) {
      this.popupkey = k;
      this.show = true;
    },
    //时间按钮处理（样式），【点击按钮，如果处在播放状态，则进入暂停，转为点击切换显示图片】
    imgBtnClick(i) {
      this.currimgbtn = i;
      this.$refs["play"].pauseing();
    },
    //天气图code选择器确认
    onConCodefirm(value, index) {
      let _arr = [];
      for (let item in index) {
        _arr.push(this.columnsVal[item][index[item]]);
      }
      //多列选项拼接成code接口参数
      this.weatherText = value.join("-");
      this.weatherCode = _arr.join("_");
      this.getData();
      this.show = false;
    },
    //气象数据公共时间选择器确认
    onConTimefirm() {
      let _date = this.$btools.fuc.formatDate(this.currentDate, "yyyy-MM-dd");
      this.startTime = _date;
      this.endTime = _date;
      this.show = false;
      this.getData();
    },
    getData() {
      let that = this;
      let _nowDate = this.$btools.fuc.formatDate(
        new Date(),
        "yyyy-MM-dd hh:mm:ss"
      );
      let _istody = this.startTime == _nowDate.split(" ")[0];
      let param;
      let _stringify;
      param = {
        user: that.$store.state.api_user,
        password: that.$store.state.api_password,
        version: 3,
        funversion: 2,
        typeCode: that.paramArr[parseInt(that.activeTab)],
        listCount: 10
      };
      _stringify =
        this.$qstring.stringify(param) +
        "&funname=weather/sat/GetDataListByTypeCodeAndTimeRange&beginTime=" +
        this.startTime +
        "%2008:00:00&endTime=" +
        this.endTime +
        "%20" +
        (_istody ? _nowDate.split(" ")[1] : "23:59:59");
      /*执行请求*/
      this.$http
        .get("/Services?" + _stringify)
        .then(r => {
          console.log("卫星图源数据：", r);
          that.realData(r["data"]);
        })
        .catch(e => {
          console.log("获取雷达云图异常:", e);
        });
    },
    //筛选出页面需要的数据集
    realData(o) {
      console.log("开始数据处理...");
      if (!o["Rows"]) {
        console.log("没有可处理数据！Rows:", o["Rows"]);
        this.mapdata = [];
        return;
      }
      let result = [];
      let _findex = o["FieldName"].indexOf("FILEPATH");
      let _minlon = o["FieldName"].indexOf("MINLON");
      let _minlat = o["FieldName"].indexOf("MINLAT");
      let _maxlon = o["FieldName"].indexOf("MAXLON");
      let _maxlat = o["FieldName"].indexOf("MAXLAT");
      let _cr = o["FieldName"].indexOf("CR"); //雷达反射强度
      let _time = o["FieldName"].indexOf("PRODUCTTIME");

      let _Arr = o["Rows"];
      try {
        for (let x = 0; x < _Arr.length; x++) {
          if (Object.keys(_Arr[x]).length <= 1) {
            continue;
          }
          let a = _Arr[x][_time].split(" ");
          let b = a[1].split(":");
          let c = _Arr[x][_findex];
          c = c.replace(/172.17.28.3/g, "124.117.223.3");
          let _m = {
            date: a[0],
            time: b[0] + ":" + b[1],
            latlon: [
              [_Arr[x][_minlat], _Arr[x][_minlon]],
              [_Arr[x][_maxlat], _Arr[x][_maxlon]]
            ],
            crdata: _cr == -1 ? [] : JSON.parse(_Arr[x][_cr]),
            imgurl: c
          };
          result.push(_m);
        }
        this.mapdata = result;
        console.log("处理前的数据：", o);
        console.log("处理后的数据：", this.mapdata);
        //this.initMap();
      } catch (e) {
        console.log("处理数据异常：", e);
      }
    },
    //模拟数据
    makeTestData() {
      this.realData({
        FieldName: [
          "ID",
          "PRODUCTTIME",
          "PRODUCTDESC",
          "TYPEDESC",
          "MINLON",
          "MAXLON",
          "MINLAT",
          "MAXLAT",
          "SATNAME",
          "PROJECTTYPE",
          "CHANNEL",
          "FILESIZE",
          "FILEMD5CHECKSUM",
          "FILEPATH"
        ],
        Rows: [
          [
            "FY4A_HDF_L_IR2_P2_ToM_20200511095625",
            "2020-05-11 09:56:25",
            null,
            null,
            70.0,
            140.0,
            15.0,
            54.0,
            "FY4A",
            "NOM",
            "NOMChannel12",
            202141,
            "a271a951e25a187119422140ba4e1080",
            "static/qixiang/1.png"
          ],
          [
            "FY4A_HDF_L_IR2_P2_ToM_20200511095218",
            "2020-05-11 09:52:18",
            null,
            null,
            70.0,
            140.0,
            15.0,
            54.0,
            "FY4A",
            "NOM",
            "NOMChannel12",
            201389,
            "678a3b1c42923e7d955befb66e465bbe",
            "https://timgsa.baidu.com/timg?image&quality=80&size=b9999_10000&sec=1589535121639&di=2ce24ea58dd7b064932b1973866967a2&imgtype=0&src=http%3A%2F%2Fimg.zcool.cn%2Fcommunity%2F01214d56daadba6ac7252ce6ea2dcc.jpg%401280w_1l_2o_100sh.jpg"
          ],
          [
            "FY4A_HDF_L_IR2_P2_ToM_20200511094556",
            "2020-05-11 09:45:56",
            null,
            null,
            70.0,
            140.0,
            15.0,
            54.0,
            "FY4A",
            "NOM",
            "NOMChannel12",
            200006,
            "53a73c76743f28975f63f457f0e0ed3d",
            "https://ss0.bdstatic.com/70cFuHSh_Q1YnxGkpoWK1HF6hhy/it/u=2320393046,3779158434&fm=26&gp=0.jpg"
          ],
          [
            "FY4A_HDF_L_IR2_P2_ToM_20200511094158",
            "2020-05-11 09:41:58",
            null,
            null,
            70.0,
            140.0,
            15.0,
            54.0,
            "FY4A",
            "NOM",
            "NOMChannel12",
            199330,
            "873f44a942515252d796a864499b100f",
            "http://172.17.28.3:10004/Services?user=admin&password=111&version=3&funname=weather/sat/GetDataByTypeCodeAndId&funversion=1&typeCode=SAT_FY4A_HDF_L_IR2_P2_ToM&id=FY4A_HDF_L_IR2_P2_ToM_20200511094158"
          ],
          [
            "FY4A_HDF_L_IR2_P2_ToM_20200511093743",
            "2020-05-11 09:37:43",
            null,
            null,
            70.0,
            140.0,
            15.0,
            54.0,
            "FY4A",
            "NOM",
            "NOMChannel12",
            198769,
            "1f71226e6b10e5c56afb241d4407d049",
            "https://ss0.bdstatic.com/70cFuHSh_Q1YnxGkpoWK1HF6hhy/it/u=1945558512,3388949498&fm=26&gp=0.jpg"
          ],
          [
            "FY4A_HDF_L_IR2_P2_ToM_20200511093105",
            "2020-05-11 09:31:05",
            null,
            null,
            70.0,
            140.0,
            15.0,
            54.0,
            "FY4A",
            "NOM",
            "NOMChannel12",
            198016,
            "f31e2b84562f48d4292c13f744cfcff1",
            "https://ss1.bdstatic.com/70cFuXSh_Q1YnxGkpoWK1HF6hhy/it/u=1483612059,4063377252&fm=26&gp=0.jpg"
          ]
        ]
      });
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/styles/index";
.satellite-container {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  height: 100%;
  width: 100%;
  background-color: rgba(0, 0, 0, 0);
  margin: 0 auto;
  .title-box {
    display: flex;
    flex-direction: row;
    height: 8%;
    //height: px2rem(58);
    width: 95%;
    .title-left {
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: center;
      height: 100%;
      width: 32.5%;
      .sign {
        width: 3px;
        height: px2rem(16);
        background-image: linear-gradient(180deg, #fe5936 0%, #fca656 100%);
      }
      span {
        font-family: PingFangSC-Semibold;
        font-size: px2rem(18);
        color: #ffffff;
        margin-left: px2rem(4);
      }
    }
    .title-right {
      height: 100%;
      width: 67.5%;
      display: flex;
      flex-direction: row;
      justify-content: flex-end;
      align-items: center;
    }
    /*border: 1px solid violet;*/
  }
  .head-box {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    //height: px2rem(45);
    height: 8%;
    width: 95%;
    .btn-tab {
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      font-size: px2rem(12);
      color: #a4a6a8;
      height: px2rem(30);
      width: px2rem(94);
      margin-right: px2rem(10);
      background: url("./image/tab.png") no-repeat center;
      background-size: 100% 100%;
    }
    .tab-active {
      background: url("./image/tab-seletd.png") no-repeat center;
      background-size: 100% 100%;
      color: #fefefe;
    }
  }
  .body-box {
    height: 82%;
    width: 95%;
    .views {
      display: flex;
      height: 50%;
      width: 100%;
      margin-top: 4%;
      // box-shadow: 3px 6px 4px rgba(0, 0, 0, 0.24), -3px -2px 3px rgba(0, 0, 0, 0.29);
      box-shadow: 0px 4px 15px 0px #120300;
      border-radius: 4px;
      img {
        height: 100%;
        width: 100%;
      }
    }
    .plays {
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: center;
      height: 46%;
      margin-top: px2rem(13);
      .slt-param {
        display: flex;
        flex-direction: row;
        justify-content: space-around;
        align-items: center;
        width: 100%;
        height: 13.3%;
        font-size: px2rem(14);
        color: #e02c00;
        border-bottom: 1px solid rgb(67, 67, 67);
        border-top: 1px solid rgb(67, 67, 67);
        span {
          white-space: nowrap;
        }
        .i-right {
          border: solid #e02c00;
          border-width: 0 2px 2px 0;
          display: inline-block;
          padding: 3px;
          margin-left: px2rem(10);
          margin-bottom: px2rem(5);
          transform: rotate(45deg);
          -webkit-transform: rotate(45deg);
        }
      }
      .slt-view {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
        overflow-x: scroll;
        height: 39%;
        width: 100%;
        .img-tabs {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          height: 100%;
          width: px2rem(67);
          margin-right: px2rem(12);
          img {
            height: px2rem(52);
            width: px2rem(67);
            margin-bottom: px2rem(6);
          }
          span {
            font-size: px2rem(12);
            color: #a3a3a3;
          }
          .active-span {
            color: #d82600;
          }
        }
        /*border:1px solid greenyellow;*/
      }
      .play-coms {
        height: 45%;
        width: 100%;
      }
    }
  }
}
</style>
